// React
import React, { useState } from 'react';

// Material-UI
import { ThemeProvider } from '@mui/system';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';


//import readingTime from 'reading-time';
import settings from './settings';
import BottomBar from './Bar/BottomBar';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

let  theme = createTheme({
  palette: {
    primary: settings.theme.primaryColor.import,
    secondary: settings.theme.secondaryColor.import,
    type: settings.theme.type
  },
});
theme = responsiveFontSizes(theme);

const App = ({ ...props }) => {

  // useFirebase(firebase => {
  //   firebase.analytics();
  //   firebase.analytics().logEvent('smartandnimble_app_rendered');
  //   firebase.performance();
  // }, [])

  const [state, setState] = useState(
    {
      snackbar: {
        autoHideDuration: 0,
        message: '',
        open: false
      },

      bottomMenu: {
        open_bottom_menu: false,
        anchorEl: null,
      },
    }
  );

  // const openSnackbar = (message) => {
  //   setState({
  //     snackbar: {
  //       autoHideDuration: readingTime(message).time * 2,
  //       message,
  //       open: true
  //     }
  //   });
  // };

  const openBottomMenu = (show, anchorEl) => {
    setState({
      bottomMenu: {
        open_bottom_menu: show,
        anchorEl: anchorEl,
      }
    })
  }

  // const closeSnackbar = (clearMessage = false) => {
  //   const { snackbar } = state;

  //   setState({
  //     snackbar: {
  //       message: clearMessage ? '' : snackbar.message,
  //       open: false
  //     }
  //   });
  // };

  const {
    //contactSupportDialog,
    //snackbar,
    bottomMenu,
  } = state;

  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LcjEMEUAAAAAAl9XvJ-aSV93nhnuzlLz60Fhf6R">
      <ThemeProvider theme={theme}>
        <div style={{ minHeight: 'calc(100vh - 3.53rem)', backgroundColor: theme.palette.type === 'dark' ? '#303030' : '#fafafa' }}>

          {props.children}

          <BottomBar anchorEl = {bottomMenu.anchorEl} openMenuFn = {(o, a) => openBottomMenu(o, a)} openMenu = {bottomMenu.open_bottom_menu} />

        </div>
      </ThemeProvider>
    </GoogleReCaptchaProvider>
  );

}

export default App;
